import React, { useCallback, useState } from 'react';
import { AppBar, Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TabPanel from 'src/components/TabPanel/TabPanel';
import { useDispatch, useSelector } from 'react-redux';
import { selectBusinessQueryOptions } from 'src/store/selectors/businessSelectors';
import { loadBusinessMetricsByPeriod } from 'src/store/actions/businessActions';
import { MetricsPeriodOptions } from 'src/utils/constants/business';
import MetricsByPeriodList from './MetricsByPeriodList';

const PERIOD_TABS = [
  MetricsPeriodOptions.HISTORIC,
  MetricsPeriodOptions.MONTH,
  MetricsPeriodOptions.QUARTER,
  MetricsPeriodOptions.YEAR
];

const MetricsByPeriodTabsList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryOpts = useSelector(selectBusinessQueryOptions);
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
      dispatch(
        loadBusinessMetricsByPeriod({
          period: PERIOD_TABS[newValue],
          metricsViewOption: queryOpts.metricsViewOption,
          year: undefined,
          month: undefined,
          page: 0
        })
      );
    },
    [dispatch, queryOpts.metricsViewOption]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          value={tabIndex}
          onChange={handleChange}
        >
          <Tab label={t('BUSINESS_VIEW.METRICS.HISTORIC')} />
          <Tab label={t('BUSINESS_VIEW.METRICS.MONTHLY')} />
          <Tab label={t('BUSINESS_VIEW.METRICS.QUARTERLY')} />
          <Tab label={t('BUSINESS_VIEW.METRICS.ANNUAL')} />
        </Tabs>
      </AppBar>

      <TabPanel value={tabIndex} index={0}>
        <MetricsByPeriodList />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <MetricsByPeriodList />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <MetricsByPeriodList />
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        <MetricsByPeriodList />
      </TabPanel>
    </Box>
  );
};

export default MetricsByPeriodTabsList;
